<h1 *ngIf="idJardinPeriodo != 0">Editar Cuenta Jardín Infantil</h1>
<h1 *ngIf="idJardinPeriodo === 0">Crear Cuenta Jardín Infantil</h1>
<form [formGroup]="formCuenta" autocomplete="off" novalidate fxLayout="column wrap"
fxLayoutAlign="center center" fxLayoutGap="10px">
<mat-dialog-content>

    <div class="contenedor"> 

       
        <h2>Datos Jardín Infantil</h2>
        <mat-divider></mat-divider>

            <table>
                <tr>
                    <td>Código Jardín Infantil:	</td>
                    <td colspan="2" *ngIf="idJardinPeriodo != 0">
                        <mat-form-field>
                            <input matInput appRut type="text" formControlName="codigo" id="codigo">                             
                            <mat-error *ngIf="hasError('codigo', 'required')">Código es requerido</mat-error>       
                        </mat-form-field>  
                    </td>
                    <td *ngIf="idJardinPeriodo === 0">
                        <mat-form-field>
                            <input matInput appRut type="text" formControlName="codigo" id="codigo">                             
                            <mat-error *ngIf="hasError('codigo', 'required')">Código es requerido</mat-error>       
                        </mat-form-field>  
                    </td>
                    <td *ngIf="idJardinPeriodo === 0">
                        <button class="btn-buscar" (click)="buscar()" [disabled]="formCuenta.controls['codigo'].value.length < 5">Buscar</button>
                    </td>
                </tr>
                <tr>
                    <td>Nombre:	</td>
                    <td colspan="2">
                        <mat-form-field>
                            <input matInput type="text" formControlName="nombreJardin" id="nombreJardin">                             
                            <mat-error *ngIf="hasError('nombreJardin', 'required')">Nombre es requerido</mat-error>            
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td>Programa:	</td>
                    <td colspan="2">
                        <mat-form-field>
                            <mat-select formControlName="programa" id="programa" name="programa" (selectionChange)="seleccionarModalidad($event.value)">
                                <mat-option value="">Seleccione Programa</mat-option>
                                <mat-option [value]="programas.idTablaMaestra" *ngFor="let programas of dataSelects.programas">{{programas.descripcionLarga}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="hasError('programa', 'required')">Programa es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td>Región:	</td>
                    <td colspan="2">  
                        <mat-form-field>
                            <mat-select formControlName="region" id="region" name="region"  (selectionChange)="seleccionarRegion()">
                                <mat-option [value]="0">Seleccione Región</mat-option>
                                <mat-option [value]="regiones.idRegion" *ngFor="let regiones of dataSelects.regiones">{{regiones.nombre}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="hasError('region', 'required')">Región es requerido</mat-error>
                            <mat-error *ngIf="hasError('region', 'min')">Región es requerido</mat-error>
                        </mat-form-field>     
                    </td>
                </tr>
                <tr>
                    <td>Comuna:	</td>
                    <td colspan="2">      
                        <mat-form-field>
                            <mat-select formControlName="comuna" id="comuna" name="comuna">
                                <mat-option [value]="-1">Seleccione Comuna</mat-option>
                                <mat-option [value]="comunas.idComuna" *ngFor="let comunas of arrayComunas">{{comunas.nombre}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="hasError('comuna', 'required')">Comuna es requerido</mat-error>
                            <mat-error *ngIf="hasError('comuna', 'min')">Comuna es requerido</mat-error>
                        </mat-form-field>   
                    </td>
                </tr>
                <tr>
                    <td>Dirección:	</td>
                    <td colspan="2">
                        <mat-form-field>
                            <input matInput type="text" formControlName="direccion" id="direccion">                             
                            <mat-error *ngIf="hasError('direccion', 'required')">Dirección es requerido</mat-error>            
                        </mat-form-field>          
                    </td>
                </tr>
                <tr>
                    <td>Teléfono:	</td>
                    <td colspan="2">
                        <mat-form-field>
                            <input matInput type="text" formControlName="telefono" id="telefono">                             
                            <mat-error *ngIf="hasError('telefono', 'required')">Teléfono es requerido</mat-error>            
                        </mat-form-field>        
                    </td>
                </tr>
                <tr>
                    <td>Modalidad:	</td>
                    <td colspan="2">
                        <mat-form-field>
                            <mat-select formControlName="modalidad" id="modalidad" name="modalidad">
                                <mat-option [value]="0">Seleccione Modalidad</mat-option>
                                <mat-option [value]="modalidades.idTablaMaestra" *ngFor="let modalidades of arrayModalidad">{{modalidades.descripcionLarga}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="hasError('modalidad', 'required')">Modalidad es requerido</mat-error>
                            <mat-error *ngIf="hasError('modalidad', 'min')">Modalidad es requerido</mat-error>
                        </mat-form-field>  
                    </td>
                </tr>
            </table>
        
            
        <h2>Datos Directora/Encargada</h2>
        <mat-divider></mat-divider>

            <table>
                <tr>
                    <td>Rut:</td>
                    <td>
                        <mat-form-field>
                            <input matInput appRut type="text" class="input-rut"  formControlName="rut" id="rut" [errorStateMatcher]="stateRutValido">                             
                            <mat-error *ngIf="hasError('rut', 'required')">Rut es requerido</mat-error>
                            <mat-error *ngIf="hasError('rut', 'minlength')">Ingrese un RUT válido</mat-error>
                            <mat-error *ngIf="hasError('rut', 'maxlength')">Ingrese un RUT válido</mat-error>
                            <p class="mat-error p-error" *ngIf="formCuenta.hasError('rutValido')">Ingrese un RUT válido</p>            
                        </mat-form-field>        
                    </td>
                </tr>
                <tr>
                    <td>Nombre Completo:</td>
                    <td>
                        <mat-form-field>
                            <input matInput type="text" formControlName="nombreDirectora" id="nombreDirectora">                             
                            <mat-error *ngIf="hasError('nombreDirectora', 'required')">Nombre Completo es requerido</mat-error>            
                        </mat-form-field>         
                    </td>
                </tr>
                <tr>
                    <td>Correo Electrónico Institucional:</td>
                    <td>
                        <mat-form-field>
                            <input matInput type="text" formControlName="correoInstitucional" id="correoInstitucional">                             
                            <mat-error *ngIf="hasError('correoInstitucional', 'required')">Correo Electrónico Institucional es requerido</mat-error>            
                            <mat-error *ngIf="hasError('correoInstitucional', 'pattern')">Ingrese un Correo electrónico válido</mat-error>
                        </mat-form-field>         
                    </td>
                </tr>
                <tr>
                    <td>Correo Electrónico Personal (opcional):</td>
                    <td>
                        <mat-form-field>
                            <input matInput type="text" formControlName="correoPersona" id="correoPersona">  
                            <mat-error *ngIf="hasError('correoPersona', 'pattern')">Ingrese un Correo electrónico válido</mat-error>                    
                        </mat-form-field>         
                    </td>
                </tr>
                <tr>
                    <td>Teléfono personal:</td>
                    <td>
                        <mat-form-field>
                            <input matInput type="text" formControlName="telefonoDirectora" id="telefonoDirectora">                             
                            <mat-error *ngIf="hasError('telefonoDirectora', 'required')">Teléfono personal es requerido</mat-error>            
                        </mat-form-field>         
                    </td>
                </tr>
            </table>
         
    </div>

</mat-dialog-content>
 

<mat-dialog-actions>
    <div class="button-row"> 
        <button mat-button mat-dialog-close class="btn-cancelar">Cancelar</button>
        <button mat-button class="btn-confirmar" (click)="guardar()">Guardar</button>
    </div>
</mat-dialog-actions>
</form>